import { useLocation } from "react-router-dom";
import {
  SUB_CAMPAIGN_ID_KEY,
  QR_SCANLOG_ID,
  ENGAGE_GET_CREDIT_SESSION,
  CHANNEL_SESSION_ID
} from "../../../../constants";

export const useLoginParams = () => {
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);

  const subCampaignId =
    searchParams.get(SUB_CAMPAIGN_ID_KEY) ||
    localStorage.getItem(SUB_CAMPAIGN_ID_KEY) ||
    "";

  const qrscanlogId =
    searchParams.get(QR_SCANLOG_ID) ||
    localStorage.getItem(QR_SCANLOG_ID) ||
    "";

  const engageGetCreditSession =
    searchParams.get(ENGAGE_GET_CREDIT_SESSION) ||
    localStorage.getItem(ENGAGE_GET_CREDIT_SESSION) ||
    "";

  const channelSessionId =
    localStorage.getItem(CHANNEL_SESSION_ID) || "";

  const merchantReference =
    searchParams.get("merchant_reference") ||
    localStorage.getItem("merchant_reference") ||
    "";

  return {
    subCampaignId,
    qrscanlogId,
    engageGetCreditSession,
    channelSessionId,
    isEGC: Boolean(searchParams.get(ENGAGE_GET_CREDIT_SESSION)),
    merchantReference,
  };
};
